import { render, staticRenderFns } from "./OpportunitiesBlockItem.vue?vue&type=template&id=0fceece8"
import script from "./OpportunitiesBlockItem.vue?vue&type=script&lang=js"
export * from "./OpportunitiesBlockItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports